// Last-known status cache for a merge run, keyed by batchId, so a finished (or long-gone) run
// can still be shown to the user after the server's own record of it has expired.

import { createBatchSnapshotStore } from 'src/utils/bulk-session/batch-snapshot-store';

const BATCH_SNAPSHOT_PREFIX = 'merge_batch_snapshot:';
const BATCH_SNAPSHOT_VERSION = 1;
const BATCH_SNAPSHOT_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
const BATCH_SNAPSHOT_MAX_COUNT = 5;

const snapshotStore = createBatchSnapshotStore({
  keyPrefix: BATCH_SNAPSHOT_PREFIX,
  version: BATCH_SNAPSHOT_VERSION,
  maxAgeMs: BATCH_SNAPSHOT_MAX_AGE_MS,
  maxCount: BATCH_SNAPSHOT_MAX_COUNT,
});

// Saves the latest known status for one merge batch and returns the envelope that was written
// (or null if storage refused the write).
export function saveMergeBatchSnapshot(batchId, { startedAt, serverStatus }) {
  return snapshotStore.save(batchId, { startedAt, serverStatus });
}

export function readMergeBatchSnapshot(batchId) {
  return snapshotStore.read(batchId);
}

// Keeps the snapshot cache from growing forever: drops anything older than 7 days, then keeps
// only the 5 most recently saved snapshots overall. Only ever looks at — and only ever removes —
// keys under this module's own prefix.
export function pruneMergeBatchSnapshots() {
  snapshotStore.prune();
}
